/* eslint-env browser */
/*
 * Toggles position: fixed on and off to emulate position: sticky
 *
 * https://getbootstrap.com/docs/3.4/javascript/#affix
 */
require('bootstrap/js/affix');
